import {
  useMutation,
  type UseMutationResult,
  useQueryClient,
} from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

import type { RejectApplicationResponse } from "../types";

import { PENDING_APPLICATIONS_QUERY_KEY } from "./useGetPendingApplications";

interface RejectParams {
  id: number;
  reason?: string;
}

export function useRejectApplication(): UseMutationResult<
  RejectApplicationResponse,
  Error,
  RejectParams
> {
  const queryClient = useQueryClient();

  return useMutation<RejectApplicationResponse, Error, RejectParams>({
    mutationFn: async ({ id, reason }) =>
      await apiClient
        .url(`/kickstarter/admin/applications/${id}/reject`)
        .post({ reason })
        .json(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PENDING_APPLICATIONS_QUERY_KEY,
      });
    },
  });
}
